export default __webpack_public_path__ + "static/media/signatureNewIcon.589ff9e3.png";